import { render, staticRenderFns } from "./dictaLM3_0.vue?vue&type=template&id=54f35454&scoped=true"
import script from "./dictaLM3_0.vue?vue&type=script&lang=js"
export * from "./dictaLM3_0.vue?vue&type=script&lang=js"
import style0 from "./dictaLM3_0.vue?vue&type=style&index=0&id=54f35454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f35454",
  null
  
)

export default component.exports